// extracted by mini-css-extract-plugin
module.exports = {"attributes-and-value-container":"social-links_attributes-and-value-container__2kRC2"};